import React, { useState } from 'react';
import Button from '../Button/Button';
import InputField from '../Auth/InputField';
import TextInputField from '../Auth/TextInputField';
import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
} from 'react-icons/fa';
import { IoArrowForward } from 'react-icons/io5';
import './SupportForm.css';
import { useContactSlotMutation } from '../../store/api/userApiSlice';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import facebook from "../../assets/images/facebook.png";
import twitter from "../../assets/images/x.png";
import youtube from "../../assets/images/youtube.png";
import instagram from "../../assets/images/instagram.png";
import linkedin from "../../assets/images/linkedin.png";
const SupportForm = () => {
  const [contactSlot, { isLoading }] = useContactSlotMutation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phNumber: '',
    text: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation Logic
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      !formData.name ||
      !formData.email ||
      !formData.phNumber ||
      !formData.text
    ) {
      toast.error("All fields are required.");
      return;
    }

    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    if (formData.phNumber.length !== 10 || isNaN(formData.phNumber)) {
      toast.error("Phone number must be 10 digits.");
      return;
    }

    try {
      const res = await contactSlot(formData).unwrap();
      if (res) {
        toast.success("Message sent successfully!");
        setFormData({ name: "", email: "", phNumber: "", text: "" });
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    }
  };

  return (
    <section className="support-section">
      <div className="support-container">
        {/* Left Side */}
        <div className="support-left">
          <h1 className="support-heading">
            Support starts with
            <br />
            <span className="highlight">A Simple Step</span>
          </h1>
          <p className="support-description">
            Whether you're starting fresh, returning for ongoing support, or
            <br />
            simply exploring your options — we're here to meet you where
            <br />
            you are. Use the form to book a session that feels right for you.
          </p>

          <div className="rating-section">
            <p className="rating-label">Trusted by 90+ Users</p>
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <p className="rating-text">
              Excellent 4.5 star rating on appstore and playstore
            </p>
          </div>

          <p className="support-note">
            Prefer to chat first? Send us an email or connect with us on
            social — we're always happy to help.
          </p>
          <div className="socials-section">
            <h4 className="socials-heading">Socials</h4>
            <div className="socials-icons">
              <a href="https://www.facebook.com/panindiajob.seeker/?viewas=100000686899395" className="social-icon" aria-label="Facebook">
                 <img src={facebook} alt="Facebook" className="social-icon" />
              </a>
              <a href="https://x.com/app_riso" className="social-icon">
              <img src={twitter} alt="twitter" className="social-icon" />
            </a>
            <a href="https://www.youtube.com/channel/UCBVAGRFnPEt9PQ8DLWycOGg" className="social-icon">
               <img src={youtube} alt="youtube" className="social-icon" />
            </a>
            <a href="https://www.instagram.com/contact.riso/" className="social-icon">
               <img src={instagram} alt="instagram" className="social-icon" />
            </a>
            <a href="https://www.linkedin.com/company/risoapp/" className="social-icon">
                <img src={linkedin} alt="linkedin" className="social-icon" />
            </a>
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="support-right">
          <h4 className="form-heading">Reach Out to Us.</h4>
          <form className="support-form" onSubmit={handleSubmit}>
            <InputField 
              type="text" 
              placeholder="Your Name*"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            <InputField 
              type="email" 
              placeholder="Your Email*"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            <InputField 
              type="number" 
              placeholder="Phone Number"
              name="phNumber"
              value={formData.phNumber}
              onChange={handleChange}
            />
            <TextInputField 
              placeholder="Write your query here*"
              name="text"
              value={formData.text}
              onChange={handleChange}
            />
            <div className="submit-button-wrapper">
              <Button type="submit" variant="teal" showArrow={false} disabled={isLoading}>
                {isLoading ? 'SENDING...' : 'SEND'}
                {!isLoading && <IoArrowForward className="send-arrow" />}
              </Button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};
export default SupportForm;
